export const GET_TIMINGS_DATA = 'timings/GET_TIMINGS_DATA';
export const GET_TIMINGS_DATA_SUCCESS = 'timings/GET_TIMINGS_DATA_SUCCESS';
export const GET_TIMINGS_DATA_FAIL = 'timings/GET_TIMINGS_DATA_FAIL';



// WEBPACK FOOTER //
// ./src/redux/constants/timings.js